// @core/api/endpoints/payment/list_payment_providers.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPaymentProvidersResponse,
} from '../../../types/payment';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/payment';

/**
 * List payment providers
 * Returns payment providers with optional filtering by type, status, or supported currency.
 */
export async function ListPaymentProviders(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPaymentProvidersResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payment-providers`;
  const requestOptions = options;
  return client.get<ListPaymentProvidersResponse>(requestPath, { ...requestOptions, params });
}
